import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  codigo: Yup.string().min(2).max(10).required(),

  _idFamilia: Yup.string().nullable(),

  _idSubFamilia: Yup.string().nullable()
})
